import { checkCurentLocation } from "@/utils/travel-date.utils";

import {
  ANNUAL_MULTI_TRIP,
  PRODUCT,
  SECONDARY_PRODUCT,
  SINGLE_TRIP,
  INT_COUNTRY,
} from "../constants";
import { RootState } from "../store/root-reducer";

const UK_REGION_COUNTRY_CODES = ["GB", "IM", "GG", "JE"];
const UK_REGION_FROM_LOCATIONS = ["UK1", "UK3", "UK4", "UK5"];

const brand: "staysure" | "avanti" | "expat" =
  SECONDARY_PRODUCT === "expat"
    ? "expat"
    : (PRODUCT as "staysure" | "avanti") ?? "staysure";

type TripDetailsType = RootState["quote"]["attributes"]["tripDetails"];

export const isUkOnly = (tripDetails: TripDetailsType) => {
  const isUKRegionFromLocation =
    tripDetails?.fromLocation &&
    UK_REGION_FROM_LOCATIONS.includes(tripDetails.fromLocation);
  const isUKRegionToLocationsOnly = (() => {
    const toLocationArr = tripDetails?.toLocation?.split(",") ?? [];
    return toLocationArr.every((substring: string) =>
      UK_REGION_COUNTRY_CODES.includes(substring)
    );
  })();

  if (
    isUKRegionFromLocation &&
    ((tripDetails?.area === "UK" &&
      tripDetails?.policyType === ANNUAL_MULTI_TRIP) ||
      (tripDetails?.policyType === SINGLE_TRIP && isUKRegionToLocationsOnly))
  ) {
    return true;
  }
  return false;
};

export const isSameCountry = (tripDetails: TripDetailsType) => {
  return checkCurentLocation(
    tripDetails?.fromLocation ?? "",
    (tripDetails?.toLocation || tripDetails?.area) ?? ""
  );
};

const shouldHideField = {
  staysure: isUkOnly,
  avanti: isUkOnly,
  expat: isSameCountry,
};

export const quoteShouldHideField =
  INT_COUNTRY !== null ? isSameCountry : shouldHideField[brand];

export function isEmptyString(value: string | null | undefined): boolean {
  return value === null || value === undefined || value?.trim() === "";
}
